import React from 'react';

import { FormField } from 'fr-shared/components';

const FormTextArea = props => <FormField component="textarea" {...props} />;
export default FormTextArea;
